import EnemyType from "../../enums/EnemyType";
import EnemyData from "./EnemyDataInterface";

const MEDIUM_ENEMYS: {
  [key in EnemyType]?: EnemyData[];
} = {
  [EnemyType.VULTURE]: [
    {
      level: 1,
      maxHp: 12,
      speed: 170,
      power: 15,
      knockback: 0.8,
      deathKB: 7,
      killedAmount: 0,
      xp: 1.5,
      spriteName: "vulture",
      animationKey: "vulture_run",
    },
  ],
  [EnemyType.GOLEM]: [
    {
      level: 10,
      maxHp: 16,
      speed: 140,
      power: 30,
      knockback: 0.1,
      deathKB: 2,
      killedAmount: 0,
      xp: 2.5,
      spriteName: "golem",
      animationKey: "golem_run",
    },
  ],
};

export default MEDIUM_ENEMYS;
